// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  clientId: 'unesp.evoto-inscricoes', // ID do sistema na Central de Acessos
  name: 'PRODUCAO',
  baseUrlApi: 'https://sistemas.unesp.br/evotoinscricoes/api',
  baseUrlRedirect: 'https://sistemas.unesp.br/evotoinscricoes/auth/',
  oauthAuthorize: 'https://auth.unesp.br/oauth/authorize',
  centralRolePrefix: 'ROLE_UNESP.EVOTO-INSCRICOES_',
  centralUrl: 'https://auth.unesp.br/',
  localStoragePrefix: 'evoto-inscricoes',
  roles: {
    centralRoleResponsavelEleicao: {
      name: 'ROLE_UNESP.EVOTO-INSCRICOES_RESPONSAVEL-ELEICAO',
      desc: 'Responsável por Eleições',
    },
    centralRoleResponsavelEleicaoInstitucional: {
      name: 'ROLE_UNESP.EVOTO-INSCRICOES_RESPONSAVEL-INSTITUC',
      desc: 'Responsável por Eleições Institucionais',
    },
    centralRoleValidacaoLocal: {
      name: 'ROLE_UNESP.EVOTO-INSCRICOES_VALIDACAO-LOCAL',
      desc: 'Validação local de Eleições Institucionais',
    },
    centralRoleCandidatura: {
      name: 'ROLE_UNESP.EVOTO-INSCRICOES_CANDIDATURA',
      desc: 'Candidatura',
    },
    centralRoleESU: {
      name: 'ROLE_UNESP.EVOTO-INSCRICOES_ESU',
      desc: 'ESU',
    },
  },
  refreshTokenExpirationInSeconds: 1800,
  refreshTokenExpirationActivityNotificationsTime: [900, 300, 150, 90, 60],
  refreshTokenExpirationLastWarningTime: 61,};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
